export const refundPayment = ({ token, paymentId, partialRefundItems }) => {
  const body = {};

  if (partialRefundItems.length > 0) {
    body.line_item_payments = partialRefundItems;
  }

  return {
    HTTPMethod: "post",
    path: `/payments/${paymentId}/refund`,
    queryParams: {},
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body,
  };
};
